import { ROUTE_PATH } from "common/constants/sm-constants";
import { MetaModel } from "common/models/utility-models/base-model";
import { GridMetaModel, Headers } from "common/models/utility-models/meta-model";
import { AssignmentReportsFilterMetaModel } from "./assignment-report-filter-meta-model";

export class AssignmentReportsGridMetaModel extends GridMetaModel<Headers> {
    filterMeta = new AssignmentReportsFilterMetaModel().getMetaModel();
    constructor() {
        super(
            'Assignment Reports',
            ROUTE_PATH.reports,
            ROUTE_PATH.reports,
            false,
            false,
            8,
            false,
            false,
            ['orgname'],
            false,
            [],
            { isDownloadExcel: true, excelFileName: 'Assignment Reports_' + new Date().toLocaleDateString() + '.xlsx', btnLabel: 'Download Assignment Report', headers: [{ key: 'StudentName', value: 'orgname' }, { key: 'CollegeName', value: 'name_of_college' }, { key: 'Branch', value: 'branch_name' }, { key: 'Assignments Assigned', value: 'totalAssignmentAssigned' }, { key: 'Assignments Attended', value: 'attended_Student' }, { key: 'Average Score', value: 'avgScore' }, { key: 'Total (%)', value: 'totalScoreInPercentage' }, { key: 'Status', value: 'statusType' }] },
            false,
            null,
            false,
            false,
            false,
            null,
            { evalKey: 'isDeletable', evalParam: [1], decisiveParam: false },
            false,
            null,
            {
                isPreview: false,
                isPreviewType: 'VIDEO',
                isEnvUrl: false,
                linkKey: ['filePath'],
                previewName: ''
            },
            {
                isTabSwitch: false,
                label: '',
                isChecked: false
            },
            true,
            true,
            false,
            [],
            false,
            { isExtraActions: false, btnLabel: '' },
            { isCheckboxEmit: false, emitKey: '', checkedKey: '', valueKey: '' },
        )
    }

    prepareHeaderList(): Headers[] {
        const headers: Headers[] = [];
        const studentName = new Headers('Student Name', 'orgname', false, false, 'text');
        const collegeName = new Headers('College Name', 'name_of_college', false, false, 'text');
        const branch = new Headers('Branch', 'branch_name', false, false, 'text');
        const totalAssignmentAssigned = new Headers('Assignments Assigned', 'totalAssignmentAssigned', false, false, 'text');
        const attended_Student = new Headers('Assignments Attended', 'attended_Student', false, false, 'text');
        const avgScore = new Headers('Average Score', 'avgScore', false, false, 'text');
        const totalScoreInPercentage = new Headers('Total %', 'totalScoreInPercentage', false, false, 'text');
        const statusType = new Headers('Status', 'statusType', false, false, 'text');

        headers.push(studentName);
        headers.push(collegeName);
        headers.push(branch);
        headers.push(totalAssignmentAssigned);
        headers.push(attended_Student);
        headers.push(avgScore);
        headers.push(totalScoreInPercentage);
        headers.push(statusType);
        return headers;
    }

    override getMetaModel(): MetaModel {
        const pageData = new MetaModel();
        pageData.pageTitle = this.pageTitle;
        pageData.properties = this.initProperties();
        pageData.redirectPath = this.redirectPath;
        pageData['filterMeta'] = this.filterMeta;
        return pageData;
    }
}